import(/* webpackMode: "eager" */ "/app/node_modules/react-toastify/dist/react-toastify.esm.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/farming/content/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/best_value_pricing.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/bg-range.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/check-filled.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/discord-icon-head.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/dot-isSelect.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/farming-airi.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/farming-metamask.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon_buy_credit_buy.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon_buy_credit_yellow.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon_check_filled_green.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon_close_button.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon_credit_yellow.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon_filter_nsfw.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon_fire_gen_campaign.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon_header_credit_yellow.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon_image_file.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon_info_aig_campaign.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon_only_Logo_aiRight.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon_pro_pricing.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon_promax_pricing.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon_started_pricing.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon_tooltip_arrow.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon_warning_yellow.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-ai-suggest-black.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-ai-suggest.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-AIG-20px.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-AIG-daily-check.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-aig-header-gray.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-AIG-header.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-AIG-refer.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-airi-token.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/Icon-Approve.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-arrow-down.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-arrow-left-white.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-arrow-left.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-arrow-right-gray.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-arrow-right-white.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-arrow-right.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-arrow-right20*20.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-artwork-leaderboard.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-back-black.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-bling-AIG-header.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-blog-footer.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-calendar_20*20.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-calendar.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-cancel-file.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-card-template-eye.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-check-attendance.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-check-chip.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-check-pricing.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-check-white.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-checkbox-gen.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-checkbox-null.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-close-chip.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-close-gray-28*28.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-close-gray.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-close-line-header.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-close.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-copy-2.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/Icon-copy-link.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-copy-refer.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-copy.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-create-ai-linear.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-create-ai-primary-linear-32*32.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-create-artwork.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-credit-flash-gray.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-credit-flash-orange.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-crown-card-trending.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-crown.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-delete-black.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-delete-white.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-dice.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-dices-16px.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-dices.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-direction.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-director-card-creator.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-discord-linear32-32.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-discord-primary-linear-32*32.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-discord-white.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-discord.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-discuss-support.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-dot-ft-campaign.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-dot-model-detail.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-dowload-white.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-down-direction.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-down-solid.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-download-image.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-download-model.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-earn-aig-profile.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-edit-black.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-elements.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-eye-card.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-eye-hidden-white.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-eye-template.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-eye.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-fast.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-feedback.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-fill-primary.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-filter.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-footer-fixed-blog.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-footer-fixed-Discord.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-footer-fixed-docs.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-footer-fixed-Medium.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-footer-fixed-Telegram.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-footer-fixed-X.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-footer-fixed-Youtube.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-for-creators.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-for-voters.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-gallery-white.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-gen-hompage.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-globe-primary.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-grid-one-active.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-grid-one.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-grid-two-active.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-grid-two.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-hastag.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-header-airi.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-header-bot.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-header-campaign.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-header-checknft.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-header-community.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-header-down.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-header-farming.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-header-feed.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-header-hover-aig.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-header-hover-bot.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-header-hover-campaign.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-header-hover-checknft.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-header-hover-farming.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-header-hover-feed.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-header-hover-leaderboard.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-header-hover-market.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-header-hover-pricing.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-header-leaderboard.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-header-market.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-header-mexc.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-header-oraidex.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-header-pancakeswap.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-header-pricing.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-heart-active.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-heart-buy-prompt-active.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-heart-buy-prompt.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-heart.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-history-white.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-idle-chip.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-info-card process.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-info-detail.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-info-gen.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-info-marketPlace.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-is-like-template.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-islike-template.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-join-discord.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-karenn.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-key.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-king.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-layer.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-left-arrow-template.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-lightning-publish.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-like-artwork.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-link-artwork.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-link-collection.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-link-primary.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-link-white.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-lock-login.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-login-google.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-login-owallet.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-logo-1.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-logo-2.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-logo-airi-60-60.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-logo-footer.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-logout.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-magic-wand-white.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-magic.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-medium-mobile.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-medium.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-menu-aimodel.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-mint-artwork.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-more.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-music-play-audio.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-new-chip.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-no-data.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-notification-active.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-notification-white.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-notification.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-notlike-template.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-option-card-template-profile.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-option-social-active.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-option-social-white.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-option-social.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-pagination-arrow-down.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-pagination-next.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-pagination-prev.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-pause-audio-black.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-pause.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-pen-orange.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-play-audio-black.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-play-audio.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-plus-primary.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-plus-white.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-plus.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-price-tag.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-profile-close.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-profile-verify.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-prompt-leaderboard.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-prompt-tag.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-push-arrow.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-rank-1st.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-rank-2st.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-rank-3st.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-redirect-green.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-refer-account.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-reload-white.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-remix-hover.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-remix-processing.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-remix-template.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-remove-post.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-reset.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-retry-artwork.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-right-arrow-template.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-rocket.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-run-model.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-search-chip.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-search-header-white.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-search-header.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-select-collection-green.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-select-model.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-send-message.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-share-buy-prompt.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-share-facebook.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-share-template.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-share-twitter.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-share.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-slide-left.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-slide-right.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-social-discord.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-social-fb.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-social-global.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-social-gmail.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-social-instagram.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-social-linkedin.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-social-medium.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-social-telegram.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-social-twitter.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-sort-mobile.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-sparkles.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-sparkling.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-success-green.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-support.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-tag-hot-mobile.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-telegram-mobile.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-telegram-primary-linear-32*32.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-telegram.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-toast-error.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-toast-success.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-toast-warn.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-token-airi.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-token-orai.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-token-usdt.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-top-up.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-top1-leaderboard.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-top2-leaderboard.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-top3-leaderboard.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-total-download-model.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-total-like-model.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-total-use-model.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-transaction-bought.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-transaction-forsale.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-transaction-mint.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-transaction-transfer.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-transaction-withdraw.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-transfer.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-trash-14*14.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-trash-22x22.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-trash-black22x22.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-twitter-campaign-card.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-twitter-linear-32*32.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-twitter-mobile.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-twitter-primary-linear-32*32.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-twitter.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-upload-file.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-use-case.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-vary.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-verify-16px.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-viewlist-white.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-warn-yellow.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-warning-circle.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-warning-support.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-warning.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-winning.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-workflow-edit.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-youtube-mobile.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/icon-youtube.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/IconBsc.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/iconRocketInPricing.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/iconSize11.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/iconSize169.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/iconSize23.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/iconSize32.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/iconSize34.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/iconSize43.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/iconSize916.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/iconSizeCustom.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/like-gradient.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/logo-home-black.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/logo-home-white.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/magic-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/magic-wand-gradient.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/most_popular_pricing.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/only_once_pricing.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/star-mintAndSell.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/toggle-sidebar-open.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/toggle-sidebar.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/top-1-creator.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/top-2-creator.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/top-3-creator.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/top-4-creator.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/upload-gradient.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/verify_account.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/airi.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/allow-popup.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/banner-shop.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/bg-banner-home.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/bg-buy-credit.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/bg-chat-room.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/bg-faq.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/bg-subcription.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/bg-suspense-homepage.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/bg-update-plan.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/bnb.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/copy.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/cursor.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/farming-airi.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/farming-bnb.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/farming-busd.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/farming-kwt.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/farming-milky.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/farming-orai.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/farming-sam.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/image_referral.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/image-404.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/image-aimodel.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/image-bg-upgrade-plan.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/image-bg-user.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/image-temp-gen-item.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/image1_mission.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/image2_mission.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/image3_mission.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/orai.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/PaperPlane1.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/PaperPlane2.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/quantum_leap-airi.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/three-dot.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/wallet.png");
